import MediaQueryHandler from './media-queries'

function tableTabletHandler(matches) {
	const tables = [...document.querySelectorAll('table')]

	const handleTableScroll = (tableWrap) => () => {
		tableWrap.classList.toggle('js-isScroll', tableWrap.scrollLeft)
	}

	const handleTableLogic = (table) => {
		const contentBlock = table.closest('.content__body')
		const tableWrap = table.closest('.table-wrap')

		if (tableWrap && table.offsetWidth > contentBlock.offsetWidth) {
			tableWrap.classList.toggle('js-isAfter', matches)
			console.log(matches);

			if (matches) {
				const scrollEventListener = handleTableScroll(tableWrap)
				tableWrap.addEventListener('scroll', scrollEventListener)

				// Removing an event handler when a condition changes
				return () => tableWrap.removeEventListener('scroll', scrollEventListener)
			}
		}
		return () => {} // Stub function for missing handler
	}

	const removeEventListeners = tables.map(handleTableLogic)

	// console.log(matches ? 'media = true' : 'media = false')

	if (!matches) {
		removeEventListeners.forEach(removeListener => removeListener())
	}
}
new MediaQueryHandler('(max-width: 1279px)', tableTabletHandler)
